import { BestPracticeData } from '@deltek/specification-client/core/Models/bestPractice'
import { MenuItemConfig } from '@deltek/specification-client/core/Models/menuItemConfig'
import { BestPracticesSetting } from '@deltek/specification-client/core/Widgets/BestPracticesSetting/BestPracticesSetting'
import {
    useBestPracticeElementData,
    useHoveredItemActions,
    useIsBestPracticeElementDataLoading,
    useIsProjectDataLoading,
    useProjectData,
} from 'components/WorkspaceEditor/HoveredItemStore'
import React, { useMemo } from 'react'

/**
 * Represents the complete configuration for a menu item, extending the base MenuItemConfig.
 */
export interface CompleteMenuItemConfig extends MenuItemConfig {
    /** Optional flag indicating whether the menu item is disabled. */
    isDisabled?: boolean
    /** Optional flag indicating whether the menu item is hidden. */
    isHidden?: boolean
    /** Optional small label text for the menu item. */
    smallLabel?: string
}

/** Props for the BestPracticesSettingPopover component. */
export interface BestPracticesSettingPopoverProps {
    /** The element to which the popover is anchored. */
    anchorElement: Element | null
    /** Indicates if the current setting is a best practice. */
    isBestPractice: boolean
    /** Indicates if the current setting is a global best practice. */
    isGlobalBestPractice: boolean
    /** Indicates if editing the best practice setting is disabled. */
    isBestPracticeEditDisabled: boolean
}

export const BestPracticesSettingPopover: React.FC<BestPracticesSettingPopoverProps> = ({
    anchorElement,
    isBestPractice,
    isGlobalBestPractice,
    isBestPracticeEditDisabled,
}) => {
    const bestPracticeElementData = useBestPracticeElementData()
    const projectData = useProjectData()
    const isProjectDataLoading = useIsProjectDataLoading()
    const isBestPracticeElementDataLoading = useIsBestPracticeElementDataLoading()
    const { setIsBPMenuDisplayed } = useHoveredItemActions()
    const isLoading = useMemo(() => {
        return isBestPracticeElementDataLoading || isProjectDataLoading
    }, [isBestPracticeElementDataLoading, isProjectDataLoading])

    //TODO: handle mutation data
    const handleBestPracticesMutationData = React.useCallback(
        (mutationData: Partial<BestPracticeData> | null) => {
            setIsBPMenuDisplayed(false)
        },
        [setIsBPMenuDisplayed]
    )
    return (
        <BestPracticesSetting
            // key={`BP-${template?.id}`}
            popoverAnchor={anchorElement}
            onlyPopover
            projectDetail={projectData?.getProject}
            setBestPracticesMutationData={handleBestPracticesMutationData}
            showBestPracticesIcons={false}
            data={bestPracticeElementData}
            loading={isLoading}
            isBestPractice={isBestPractice}
            isGlobalBestPractice={isGlobalBestPractice}
            isDisabled={isBestPracticeEditDisabled}
        />
    )
}
